import Chat from "@/components/Chat";
import ToggleChat from "@/components/ToggleChat";

const Layout = () => {
    return (
        <ToggleChat>
            <Chat />
        </ToggleChat>
    );
};

export default Layout;
